import { Component, Input } from '@angular/core';
import { DocumentService } from '@cupoui/core/services/document.service';
import { NGXLogger } from 'ngx-logger';
import { BusinessAreaEnum } from '@cupoui/shared/model/enumerations/business-area.enum';

@Component({
    selector: 'app-open-invoice-pdf',
    templateUrl: './open-invoice-pdf.component.html',
    styleUrls: ['./open-invoice-pdf.component.scss'],
    standalone: false
})
export class OpenInvoicePdfComponent {
  @Input() invoiceDocumentId: string;
  @Input() businessArea: BusinessAreaEnum;
  loading = false;
  error = false;
  errorMessage = '';

  constructor(private documentService: DocumentService, private logger: NGXLogger) {
  }

  getAndOpenInvoicePDF(invoiceDocumentId: string, businessArea: BusinessAreaEnum): void {
    this.loading = true;
    this.error = false;
    this.errorMessage = '';
    this.documentService.getDocumentByForBusinessArea(invoiceDocumentId, businessArea).subscribe(
      result => {
        this.loading = false;
        const url = window.URL.createObjectURL(result);
        window.open(url);
      },
      error => {
        this.loading = false;
        this.error = true;
        this.errorMessage = error.message;
        this.logger.debug(error);
      }
    );
  }
}
